export const EShapeActionValueTransformType = wcardinal.ui.EShapeActionValueTransformType;